/**
 * Main Article Section JavaScript
 * Handles share functionality
 */

document.addEventListener("DOMContentLoaded", function () {
  const shareButton = document.querySelector("[data-share-url]");
  const shareFeedback = document.querySelector("[data-share-feedback]");

  if (shareButton && shareFeedback) {
    shareButton.addEventListener("click", function () {
      const url = this.getAttribute("data-share-url");
      const title = this.getAttribute("data-share-title");

      // Try to use the Web Share API if available (mobile devices)
      if (navigator.share) {
        navigator
          .share({
            title: title,
            url: url,
          })
          .then(() => {
            showFeedback("Shared!");
          })
          .catch((error) => {
            // If user cancels, just silently fail
            if (error.name !== "AbortError") {
              fallbackCopyToClipboard(url);
            }
          });
      } else {
        // Fallback to copying to clipboard
        fallbackCopyToClipboard(url);
      }
    });
  }

  function fallbackCopyToClipboard(url) {
    // Use modern Clipboard API if available
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          showFeedback("Link copied!");
        })
        .catch(() => {
          showFeedback("Failed to copy");
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        showFeedback("Link copied!");
      } catch (err) {
        showFeedback("Failed to copy");
      }
      document.body.removeChild(textArea);
    }
  }

  function showFeedback(message) {
    if (shareFeedback) {
      shareFeedback.textContent = message;
      shareFeedback.classList.add("main-article__share-feedback--visible");

      setTimeout(() => {
        shareFeedback.classList.remove("main-article__share-feedback--visible");
      }, 2000);
    }
  }
});
